import faker from 'faker';

import {
  IPaymentPlan,
  IPaymentPlanData,
  IPaymentPlanSchedule,
  IPaymentPlanScheduleData
} from '../payment-plan.types';
import { PaymentPlan, PaymentPlanSchedule } from '../payment-plan';
import { createRange } from '@/utils/helpers';

export function createRandomPaymentPlan(): IPaymentPlanData {
  return {
    id: faker.datatype.number(),
    quote: faker.datatype.number(),
    ex_factory_date: faker.date.past().toISOString(),
    csi_order_number: faker.datatype.string(),
    state: faker.datatype.number(),
    schedules: mockPaymentPlanSchedulesData,
    created: faker.date.past().toISOString(),
    modified: faker.date.recent().toISOString()
  };
}

export function createRandomPaymentPlanSchedule(): IPaymentPlanScheduleData {
  return {
    id: faker.datatype.number(),
    payment_type: faker.datatype.number(),
    due_date: faker.date.future().toISOString(),
    fixed_amount: faker.finance.amount(),
    percentage: null,
    invoice: faker.datatype.number()
  };
}

export const mockPaymentPlanSchedulesData: IPaymentPlanScheduleData[] = createRange(
  4
).map(() => createRandomPaymentPlanSchedule());

export const mockPaymentPlansData: IPaymentPlanData[] = createRange(5).map(() =>
  createRandomPaymentPlan()
);

export const mockPaymentPlans = (
  data: IPaymentPlanData[] = mockPaymentPlansData
): IPaymentPlan[] => data.map(item => new PaymentPlan(item));

export const mockPaymentPlanSchedules = (
  data: IPaymentPlanScheduleData[] = mockPaymentPlanSchedulesData
): IPaymentPlanSchedule[] => data.map(item => new PaymentPlanSchedule(item));

export const mockPaginatedPaymentPlan = {
  count: mockPaymentPlansData.length,
  next: null,
  previous: null,
  results: mockPaymentPlanSchedules
};
